import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M22.5 18h-.75V5.25a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5V18H1.5a.75.75 0 1 0 0 1.5h21a.75.75 0 1 0 0-1.5m-2.25 0H13.5v-1.5a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 .75.75zm0-4.5a.75.75 0 1 1-1.5 0V6.75H5.25v10.5a.75.75 0 1 1-1.5 0V6a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 .75.75z"
    }, null, -1)
  ])))
}
export default { render: render }